@if (varietyProperties$ | async; as varietyProperties) {
  <app-advice-card
    [title]="'TGA.Advice.General.DashboardWidget.Title' | translate: { variety: varietyProperties.cropVariety }"
  >
    <app-risk-legend [isVarietyProperties]="true"></app-risk-legend>
    <mat-table [dataSource]="varietyProperties.properties">
      <ng-container matColumnDef="varietyProperty">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.name | translate }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="propertyValues">
        <mat-header-cell *matHeaderCellDef class="variety-header-cell">{{
          varietyProperties.cropVariety | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element" [class.increased-risk]="!!element.isIncreasedRisk">
          @if (element.valueGroups?.length) {
            @for (group of element.valueGroups; track group; let groupIndex = $index) {
              <span class="values-container">
                @for (value of group; track value; let valueIndex = $index) {
                  {{ value | translate }}
                }
              </span>
            }
          } @else {
            <span>-</span>
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="['varietyProperty', 'propertyValues']"></mat-header-row>
      <mat-row *matRowDef="let row; columns: ['varietyProperty', 'propertyValues']"></mat-row>
    </mat-table>
  </app-advice-card>
} @else {
  <div class="loading-container">
    <app-loading-card [loadingText]="'BFP.UI.Loading'" />
  </div>
}
